import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { useLowBalanceAlert } from "context/LowBalanceAlertContext";

const GlobalLowBalanceAlert = () => {

    const navigate = useNavigate();

    const {
        showAlert,
        setShowAlert,
    } = useLowBalanceAlert();

    const userData = JSON.parse(localStorage.getItem("userData"));

    if (!userData) return null;
    
    const available =
        Number(userData.wallet.free_credit ?? 0) +
        Number(userData.wallet.paid_credit ?? 0);

    return (
        <Modal isOpen={showAlert} centered>

            <ModalHeader>
                Low Balance
            </ModalHeader>

            <ModalBody>

                Your available credits are

                <h3>${available}</h3>

                Please add credits.

            </ModalBody>

            <ModalFooter>

                <Button
                    onClick={() => setShowAlert(false)}
                >
                    Later
                </Button>

                <Button
                    style={{ backgroundColor: "#00ADF0", color: "white" }}
                    onClick={() => {
                        setShowAlert(false);
                        navigate("/payments");
                    }}
                    outline
                >
                    Add Credits
                </Button>

            </ModalFooter>

        </Modal>
    );
};

export default GlobalLowBalanceAlert;

